import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const clientReportApi = createApi({
    reducerPath: 'clientReportApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/reports",
    }),
    tagTypes: ["Report"],
    endpoints: (builder) => ({
        resendClientReport: builder.mutation({
            query: ({ data, id }) => ({
                url: `/school/resend_report_submit/${id}`,
                method: 'PUT',
                data
            }),
            invalidatesTags: ["Report"]
        }),
    }),
})

export const {
    useResendClientReportMutation
} = clientReportApi;